import { ClientUser } from '@app/shared/models/client-user';

export class AuthUser extends ClientUser {
    public permissions: string[];
    public modules: string[];
    public pages: string[];
    public offline: boolean;
    public wrongLoginCount: number;
    public support_origin: string;

    constructor(json?: any) {
        super(json);
    }

    protected setObjectMappings(json: any): any {
        return Object.assign(super.setObjectMappings(json), {
            permissions: json && json.permissions ? json.permissions : [],
            modules: json && json.modules ? json.modules : [],
            pages: json && json.pages ? json.pages : [],
            firstname: json && json.firstname ? json.firstname : (json.firstName ? json.firstName : ''),
            lastname: json && json.lastname ? json.lastname : (json.lastName ? json.lastName : ''),
            roles: json && json.roles ? json.roles : []
        });
    }
}
